<template>
  <div>
    <div class="row py-3 mb-4 border-bottom align-items-center">
      <div class="col">
        <h1 class="company-h1">
          <button type="button" class="btn btn-back" @click="$router.push('/companies')" />
          Create Company
        </h1>
      </div>
    </div>
    <div class="row pt-5 company-created">
      <div class="col-4 mx-auto align-middle text-center">
        <img class="w-75" src="../../assets/img/company-info.png" />
        <br />
        <h4>Company Created</h4>
        <p>We created company but we need more info to finish onboarding</p>
        <button class="btn btn-primary" @click="setCompanyStep('companies-map')">FINISH COMPANY SETUP</button><br />
        <button class="btn btn-link" @click="$router.push('/companies')">Do it later</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      step: state => state.companies.step,
    }),
  },
  methods: {
    ...mapMutations(['setCompanyStep']),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/companies/CompaniesCreated.vue